import { slideDown, slideUp } from '~/js/helpers';

const SLIDE_DURATION_MS = 300;

export function initDetailsAnimation(allOpen = true) {
	document.addEventListener(
		'click',
		(e) => {
			const detail = e.target.closest('details');

			if (!detail) {
				return;
			}

			const content = detail.querySelector('.details-content');

			if (!content) {
				return;
			}

			const summary = detail.querySelector('summary');
			const clickedSummary = summary && summary.contains(e.target);
			const clickedInsideContent = content.contains(e.target);

			if (!clickedSummary || clickedInsideContent) {
				return;
			}

			// Stop native <details> toggle; visibility is driven by .open + slide helpers.
			e.preventDefault();

			if (!allOpen) {
				const siblings = detail.parentNode?.querySelectorAll('details') || [];

				siblings.forEach((sibling) => {
					if (sibling === detail || !sibling.classList.contains('open')) {
						return;
					}

					const siblingContent = sibling.querySelector('.details-content');

					if (!siblingContent) {
						return;
					}

					slideUp(siblingContent, SLIDE_DURATION_MS);
					sibling.classList.remove('open');

					window.setTimeout(() => {
						if (window.getComputedStyle(siblingContent).display === 'none') {
							siblingContent.classList.add('hidden');
						}
					}, SLIDE_DURATION_MS);
				});
			}

			const isOpening = !detail.classList.contains('open');

			if (isOpening) {
				content.classList.remove('hidden');
				slideDown(content, SLIDE_DURATION_MS);
				detail.classList.add('open');
			} else {
				slideUp(content, SLIDE_DURATION_MS);
				detail.classList.remove('open');

				window.setTimeout(() => {
					if (window.getComputedStyle(content).display === 'none') {
						content.classList.add('hidden');
					}
				}, SLIDE_DURATION_MS);
			}
		},
		true
	);
}
